"use client";

import { Box, ButtonGroup, Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import { colors } from "../../theme/colors";
export default function HeaderLanguageControl() {
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      setSelectedLanguage(storedLanguage);
    }
  }, []);
  const handleLanguageChange = language => {
    setSelectedLanguage(language);
    localStorage.setItem("language", language);
    window.dispatchEvent(new Event("storage"));
  };
  const buttonStyle = isActive => ({
    px: 2,
    py: 0.75,
    fontSize: '13px',
    fontWeight: isActive ? 600 : 500,
    textTransform: 'none',
    borderRadius: 0,
    backgroundColor: isActive ? colors.primary.main : 'transparent',
    color: isActive ? 'white' : colors.text.tertiary,
    border: `1px solid ${colors.border.light}`,
    transition: 'all 0.2s ease',
    minWidth: '44px',
    height: '32px',
    '&:hover': {
      backgroundColor: isActive ? colors.primary.hover : colors.background.light,
      color: isActive ? 'white' : colors.text.secondary
    },
    '&:first-of-type': {
      borderTopLeftRadius: '6px',
      borderBottomLeftRadius: '6px'
    },
    '&:last-of-type': {
      borderTopRightRadius: '6px',
      borderBottomRightRadius: '6px',
      borderLeft: 'none'
    }
  });
  return <Box sx={{
    display: 'flex',
    alignItems: 'center'
  }} data-sentry-element="Box" data-sentry-component="HeaderLanguageControl" data-sentry-source-file="HeaderLanguageControl.jsx">
      <ButtonGroup variant="outlined" sx={{
      boxShadow: 'none',
      '& .MuiButtonGroup-grouped': {
        minWidth: 'auto'
      }
    }} data-sentry-element="ButtonGroup" data-sentry-source-file="HeaderLanguageControl.jsx">
        <Button onClick={() => handleLanguageChange('en')} sx={buttonStyle(selectedLanguage === 'en')} disableElevation data-sentry-element="Button" data-sentry-source-file="HeaderLanguageControl.jsx">
          EN
        </Button>
        <Button onClick={() => handleLanguageChange('de')} sx={buttonStyle(selectedLanguage === 'de')} disableElevation data-sentry-element="Button" data-sentry-source-file="HeaderLanguageControl.jsx">
          DE
        </Button>
      </ButtonGroup>
    </Box>;
}